import {
	FaClock,
	FaCode,
	FaCodeBranch,
	FaDollarSign,
	FaPen,
	FaQuestion,
	FaRegComment,
	FaRegCommentAlt,
	FaRandom,
	FaSitemap,
	FaTag,
	FaTasks,
	FaTerminal,
	FaTicketAlt,
	FaUserNinja,
} from "react-icons/fa";
import { FaRobot } from "react-icons/fa";
import { MdOpenInNew } from "react-icons/md";
import { TiFlowMerge } from "react-icons/ti";

// Metadados por tipo de ação (ícone + título). Nível de módulo para ser
// reutilizado tanto pelo header do modal quanto pela busca de nós (ticket 02).
const ACTION_META = {
	message: {
		icon: <FaRegComment size={22} color="#454962" />,
		title: "Mensagens",
	},
	gush: {
		icon: <FaUserNinja size={22} color="#454962" />,
		title: "Transferencia",
	},
	createtask: {
		icon: <FaTasks size={22} color="#454962" />,
		title: "Criar tarefa",
	},
	createdeal: {
		icon: <FaDollarSign size={22} color="#454962" />,
		title: "Criar de negócio na Rvops",
	},
	createticket: {
		icon: <FaTicketAlt size={22} color="#454962" />,
		title: "Criar ticket",
	},
	sleep: {
		icon: <FaClock size={22} color="#454962" />,
		title: "Atraso",
	},
	setvar: {
		icon: <FaPen size={22} color="#454962" />,
		title: "Definir valor de uma variável",
	},
	settag: {
		icon: <FaTag size={22} color="#454962" />,
		title: "Definir Tags na conversa",
	},
	webhook: {
		icon: <FaTerminal size={22} color="#454962" />,
		title: "Enviar Webhook",
	},
	aiagent: {
		icon: <FaRobot size={22} color="#454962" />,
		title: "Agente de IA",
	},
	question: {
		icon: <FaQuestion size={22} color="#454962" />,
		title: "Pergunta",
	},
	conditional: {
		icon: <FaCodeBranch size={22} color="#454962" />,
		title: "Condicional",
	},
	jump: {
		icon: <FaSitemap size={22} color="#454962" />,
		title: "Keyword Jump",
	},
	outputbalancer: {
		icon: <FaRandom size={22} color="#454962" />,
		title: "Balanceador de saídas",
	},
	newVar: {
		icon: <FaCode size={22} color="#454962" />,
		title: "Cadastrar nova variável",
	},
	editVar: {
		icon: <FaCode size={22} color="#454962" />,
		title: "Editar variável",
	},
	createnote: {
		icon: <FaRegCommentAlt size={22} color="#454962" />,
		title: "Adicionar anotação",
	},
	wppFlows: {
		icon: <TiFlowMerge size={22} color="#454962" />,
		title: "Whatsapp Flows",
	},
};

// Título legível ("nome do evento") de um tipo de ação. Usado pela busca.
function getActionTitle(type) {
	return ACTION_META[type]?.title || "";
}

function handleHeaderByType(type) {
	const currentType = ACTION_META[type];

	if (currentType) {
		return (
			<>
				{currentType.icon}
				<div>
					<span>{currentType.title}</span>
					{currentType.link && (
						<div className="modalHeader-link">
							<a href={currentType.link.url}>
								{currentType.link.title}
								<MdOpenInNew />
							</a>
						</div>
					)}
				</div>
			</>
		);
	}
	return "";
}

export { handleHeaderByType, getActionTitle, ACTION_META };
